export const educationOptions = [
  { label: 'Select', value: '' },
  {
    label: 'Primary Education',
    value: 'primary_education'
  },
  {
    label: 'Secondary Education',
    value: 'secondary_education'
  },
  {
    label: 'Tertiary Education',
    value: 'tertiary_education'
  },
  {
    label: 'Undergraduate Degree',
    value: 'undergraduate_degree'
  },
  {
    label: 'Graduate Degree',
    value: 'graduate_degree'
  },
  {
    label: 'Postgraduate Degree',
    value: 'postgraduate_degree'
  },
  {
    label: 'Doctoral Degree',
    value: 'doctoral_degree'
  },
  {
    label: 'Vocational Training',
    value: 'vocational_training'
  }
];
